// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"772fe221","455":"e782d649","977":"a828a8b0"}[chunkId] + ".chunk.js";
};